import React, {MouseEvent, ReactNode} from 'react';
import {t} from '@lingui/core/macro';

import MoreActionsItem from 'shared/ui/MoreActions/MoreActionsItem';
import MoreActionsDots from 'shared/ui/MoreActions/MoreActionsDots';
import Suspend from 'shared/ui/icons/General/Suspend';
import TurnOn from 'shared/ui/icons/General/TurnOn';
import Edit from 'shared/ui/icons/General/Edit';
import Key from 'shared/ui/icons/General/Key';
import Delete from 'shared/ui/icons/General/Delete';
import Tags from 'shared/ui/icons/TablesMenu/Tags';
import MoreDetailed from 'shared/ui/icons/General/MoreDetailed';
import IServerOutput from 'features/server/model/Server/IServer';
import {PALETTE} from 'shared/config/model/palette';

interface IServerMenuProps {
    item: IServerOutput,
    // eslint-disable-next-line no-unused-vars
    onEditClick: (event: MouseEvent) => void,
    // eslint-disable-next-line no-unused-vars
    onTagsClick: (event: MouseEvent) => void,
    // eslint-disable-next-line no-unused-vars
    onDetailsClick: (event: MouseEvent) => void,
    // eslint-disable-next-line no-unused-vars
    onPauseClick: (event: MouseEvent) => void,
    // eslint-disable-next-line no-unused-vars
    onResumeClick: (event: MouseEvent) => void,
    // eslint-disable-next-line no-unused-vars
    onSetTokenClick: (event: MouseEvent) => void,
    // eslint-disable-next-line no-unused-vars
    onRegenerateTokenClick: (event: MouseEvent) => void,
    // eslint-disable-next-line no-unused-vars
    onDeleteClick: (event: MouseEvent) => void,
}

const ServerMenu: React.FC<IServerMenuProps> = ({
    item,
    onEditClick,
    onTagsClick,
    onDetailsClick,
    onPauseClick,
    onResumeClick,
    onSetTokenClick,
    onRegenerateTokenClick,
    onDeleteClick,
}) => {
    const getActions = (): ReactNode[] => {
        const actions: ReactNode[] = [];

        actions.push(
            <MoreActionsItem
                key="edit"
                label={t`Редактировать`}
                icon={<Edit/>}
                onClick={onEditClick}
                data-modal-trigger="true"
            />,
            <MoreActionsItem
                key="tags"
                label={t`Теги`}
                icon={<Tags/>}
                onClick={onTagsClick}
                data-modal-trigger="true"
            />,
            <MoreActionsItem
                key="details"
                label={t`Подробнее`}
                icon={<MoreDetailed/>}
                onClick={onDetailsClick}
            />,
        );

        if (item.status === 'paused') {
            actions.push(
                <MoreActionsItem
                    key="resume"
                    label={t`Возобновить`}
                    icon={<TurnOn/>}
                    onClick={onResumeClick}
                    data-modal-trigger="true"
                />,
            );
        } else {
            actions.push(
                <MoreActionsItem
                    key="pause"
                    label={t`На паузу`}
                    icon={<Suspend/>}
                    onClick={onPauseClick}
                    data-modal-trigger="true"
                />,
            );
        }

        if (item.status === 'pending') {
            actions.push(
                <MoreActionsItem
                    key="setToken"
                    label={t`Подключение агента`}
                    icon={<Key color={PALETTE.neutral}/>}
                    onClick={onSetTokenClick}
                    data-modal-trigger="true"
                />,
            );
        }

        actions.push(
            <MoreActionsItem
                key="regenerate"
                label={t`Перевыпустить токен`}
                icon={<Key color={PALETTE.neutral}/>}
                onClick={onRegenerateTokenClick}
                data-modal-trigger="true"
            />,
        );

        actions.push(
            <MoreActionsItem
                key="trash"
                label={t`Удалить`}
                icon={<Delete/>}
                onClick={onDeleteClick}
                data-modal-trigger="true"
            />,
        );

        return actions;
    };

    return (
        <MoreActionsDots placement="auto">
            {getActions().map(el => el)}
        </MoreActionsDots>
    );
};

export default React.memo(ServerMenu);
